import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { WelcomeComponent } from './welcome/welcome.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: {
      description: 'Evaltrix is the leading AI-powered assessment platform for hiring, training, and educational institutions.'
    }
  },
  {
    path: 'login',
    loadChildren: () => import('./login-register/login-register.module').then(m => m.LoginModule),
    data: {
      title: 'Login',
      description: 'Login to your Evaltrix account to manage assessments, candidates, and reports.'
    }
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    data: {
      title: 'Dashboard',
      description: 'Manage your assessments and view reports on your Evaltrix dashboard.'
    }
  },
  {
    path: 'candidate',
    loadChildren: () => import('./candidate/candidate.module').then(m => m.CandidateModule),
    data: {
      title: 'Candidate Portal',
      description: 'Candidate portal for taking assessments on Evaltrix.'
    }
  },
  {
    path: 'demo',
    loadChildren: () => import('./demo/demo.module').then(m => m.DemoModule),
    data: {
      title: 'Request Demo',
      description: 'Request a demo to see how Evaltrix can help you streamline your assessment process.'
    }
  },
  {
    path: 'welcome',
    canActivate: [AuthGuard],
    component: WelcomeComponent,
    data: {
      title: 'Welcome',
      description: 'Welcome to Evaltrix.'
    }
  },
  {
    path: 'about',
    loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule),
    data: {
      title: 'About Us',
      description: 'Learn more about Evaltrix and our mission to revolutionize assessments.'
    }
  },
  {
    path: 'verify-entrepreneur',
    loadChildren: () => import('./verify-mail/verify-mail.module').then(m => m.VerifyMailModule),
    data: {
      title: 'Verify Email',
      description: 'Verify your email address to complete your registration.'
    }
  },
  { path: '**', redirectTo: '/dashboard/home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
